module.exports = "<qms-navigation-menu-element title=\"Faculties\" translation=\"global.menu.management.faculties\" [link]=\"['faculties']\" [selected]=\"active && !selectedElement\"> <qms-navigation-menu-element *ngFor=\"let faculty of faculties|async\" [title]=\"faculty.name\" [link]=\"['faculties/details', faculty.id]\" [model]=\"faculty\" [selected]=\"isSelected(faculty.id)\"> </qms-navigation-menu-element> </qms-navigation-menu-element> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/components/management/management-navigation-menu/faculties-management-navigation-menu/faculties-management-navigation-menu.component.html
// module id = 275
// module chunks = 0